import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, EventEmitter, HostBinding, Output, ViewChild, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ScrollAdapterComponent } from '@frontend/sports/common/core/feature/scroll-adapter';
import { DsCard } from '@frontend/ui/card';
import { SpeculativeLinkDirective } from '@frontend/vanilla/features/speculative-link';
import { RxFor } from '@rx-angular/template/for';
import { EventCarouselSkeletonComponent } from 'packages/sports/web/app/src/event-carousel/event-carousel-skeleton/event-carousel-skeleton.component';
import { Subject } from 'rxjs';

import { ScrollSelectedInViewDirective } from '../directives/scroll-selected-in-view/scroll-selected-in-view.directive';
import { EventCarouselItem } from './event-carousel.model';
import { EventDetailCardComponent } from './event-detail-card/event-detail-card.component';

@Component({
    selector: 'ms-event-carousel',
    imports: [
        RxFor,
        CommonModule,
        ScrollAdapterComponent,
        ScrollSelectedInViewDirective,
        EventDetailCardComponent,
        EventCarouselSkeletonComponent,
        SpeculativeLinkDirective,
        DsCard,
    ],
    templateUrl: './event-carousel.component.html',
    styleUrl: './event-carousel.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventCarouselComponent {
    @HostBinding('class') class = 'event-carousel-container';
    @Output() eventTileClicked = new EventEmitter<{ eventCarouselItem: EventCarouselItem; tileIndex: number }>();

    @ViewChild(ScrollAdapterComponent, { static: true }) private scrollAdapter: ScrollAdapterComponent;

    eventCarouselItems = input.required<EventCarouselItem[]>();
    activeEventId = input<string>();
    isLoading = input<boolean>();

    itemsRendered = new Subject<EventCarouselItem[]>();

    private readonly destroyRef = inject(DestroyRef);

    constructor() {
        this.itemsRendered.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            this.scrollAdapter?.setArrows();
        });
    }

    tileClick(eventCarouselItem: EventCarouselItem, index: number): void {
        this.eventTileClicked.emit({ eventCarouselItem, tileIndex: index });
    }

    trackByEventId(_: number, eventItem: EventCarouselItem): string | undefined {
        return eventItem.event.id;
    }
}
